export default {
  // ページタイトル
  title: 'アクティビティ詳細',
  // KPI カード
  participantCount: '参加者数',
  winnerCount: '当選者数',
  loserCount: '落選者数',
  yesterday: '昨日:',
  // タブラベル
  tabBasic: '基本情報',
  tabScope: 'アクティビティ範囲',
  tabPrize: 'アクティビティ賞品',
  tabStrategy: 'アクティビティ戦略',
  // 基本情報
  activityStatus: 'アクティビティステータス',
  activityName: 'アクティビティ名',
  activityId: 'アクティビティID',
  activityTemplate: 'アクティビティテンプレート',
  activityTime: 'アクティビティ期間',
  activityRemark: 'アクティビティ備考',
  activityRule: 'アクティビティルール',
  createTime: '作成時間',
  // アクティビティ範囲
  colRangeType: '範囲タイプ',
  colCodeRange: 'コード範囲',
  colCodeCount: 'コード数',
  emptyScope: 'アクティビティ範囲データがありません',
  // アクティビティ賞品
  colPrizeName: '賞品名',
  colPrizePercent: '当選確率',
  colPrizeContent: '賞品内容',
  colPrizePloy: '関連戦略',
  emptyPrize: 'アクティビティ賞品データがありません',
  // アクティビティ戦略
  colStrategyName: '戦略名',
  colStrategyRules: '戦略ルール',
  colStrategyStatus: '戦略ステータス',
  emptyStrategy: 'アクティビティ戦略データがありません',
};
